import React, { useEffect, useState, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { baseUrl } from '../Helper/links';
import { Toast } from 'primereact/toast';

function UsersAppActive() {
    const [onlineUsers, setOnlineUsers] = useState([]);
    const [count, setCount] = useState(0);
    const toast = useRef(null);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        if (!window.Pusher) {
            console.error("Pusher library not loaded");
            return;
        }

        const token = window.localStorage.getItem('token');

        // Initialize Pusher
        const pusher = new window.Pusher('d98d9be156c58021a369', {
            cluster: 'eu',
            authEndpoint: `${baseUrl}pusher/auth_pusher.php`,
            auth: {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }
        });

        const channel = pusher.subscribe('presence-online-users');

        channel.bind('pusher:subscription_succeeded', (members) => {
            setLoading(true);
            const users = [];
            members.each((member) => {
                users.push({ id: member.id, info: member.info });
            });
            setOnlineUsers(users);
            setCount(members.count);
            setLoading(false);
        });

        channel.bind('pusher:member_added', (member) => {
            setLoading(true);
            setOnlineUsers((prev) => [...prev, { id: member.id, info: member.info }]);
            setCount((prev) => prev + 1);
            toast.current.show({ severity: 'info', summary: 'مستخدم متصل', detail: `${member.info.name} دخل الآن`, life: 3000 });
            setLoading(false);
        });

        channel.bind('pusher:member_removed', (member) => {
            setLoading(true);
            setOnlineUsers((prev) => prev.filter(u => u.id !== member.id));
            setCount((prev) => Math.max(0, prev - 1));
            setLoading(false);
        });

        return () => {
            pusher.unsubscribe('presence-online-users');
            pusher.disconnect();
        };

    }, []);

    const nameBody = (rowData) => {
        return (
            <div className="flex align-items-center gap-2">
                <i className="fa fa-user-circle-o ml-2" style={{ fontSize: '1.2rem', color: rowData.id.toString().startsWith('admin') ? '#ffc107' : '#28a745' }}></i>
                <span>{rowData.info.name}</span>
            </div>
        );
    };

    const typeBody = (rowData) => {
        const isAdmin = rowData.id.toString().startsWith('admin');
        return <Tag value={isAdmin ? 'مسؤول' : 'مستخدم'} severity={isAdmin ? 'warning' : 'success'} />;
    };

    return (
        <div className="page-wrapper" dir="rtl">
            <div className="content-wrapper">
                <Toast ref={toast} position="top-center" style={{ fontFamily: "Cairo" }} />
                <div className="page-heading d-flex justify-content-between align-items-center">
                    <h1 className="page-title">المستخدمين المتصلين حالياً</h1>
                    <div className="badge badge-success p-2" style={{ fontSize: '1.1rem' }}>
                        إجمالي المتصلين: {count}
                    </div>
                </div>

                <div className="card mt-4">
                    <DataTable value={onlineUsers} responsiveLayout="stack" breakpoint="960px"
                        emptyMessage={<center><h4 className='m-5'>لا يوجد مستخدمين متصلين حالياً</h4></center>}
                        style={{ fontFamily: 'Cairo' }}
                        className="p-datatable-striped" loading={loading} >
                        <Column field="id" header="المعرف" style={{ width: '20%', textAlign: "right" }}></Column>
                        <Column body={nameBody} header="الاسم" style={{ width: '50%', textAlign: "right" }}></Column>
                        <Column field="info.phone" header="رقم الهاتف" style={{ width: '50%', textAlign: "right" }}></Column>

                        <Column body={typeBody} header="النوع" style={{ width: '30%', textAlign: "right" }}></Column>
                    </DataTable>
                </div>
            </div>
            <style>{`
                .page-title { font-family: 'Cairo', sans-serif; }
                .p-column-title { font-family: 'Cairo', sans-serif; font-weight: bold; }
                .p-datatable { border-radius: 12px; overflow: hidden; box-shadow: 0 4px 6px rgba(0,0,0,0.1); }
            `}</style>
        </div>
    );
}

export default UsersAppActive;